export type KeyValueOrder = { key: string; value: string; order?: number };

export const ExcelProjectCooperatorItemsFields = [
    // Same structure as ProjectItems (A-G)
    { key: 'Id', value: 'Id', order: undefined },
    { key: 'Ordinal', value: 'Redni broj', order: 0 },
    { key: 'Name', value: 'Opis/Naziv', order: 1 },
    { key: 'UnitOfMeasurement', value: 'Jedinica mjere', order: 2 },
    { key: 'Quantity', value: 'Količina', order: 3 },
    { key: 'UnitPrice', value: 'Jedinična cijena', order: 4 },
    { key: 'TotalPrice', value: 'Ukupna cijena', order: 5 },
    // New contractor-specific columns (H-J)
    { key: 'ContractorQuantity', value: 'Količina izvođača', order: 6 },
    { key: 'ContractorUnitPrice', value: 'Jedinična cijena izvođača', order: 7 },
    { key: 'ContractorTotalPrice', value: 'Ukupna cijena izvođača', order: 8 },
] as KeyValueOrder[];
